import {
    FolderOpen,
    CircleCheckBig,
    UserCheck,
    BrushCleaning,
    TriangleAlert,
    Shredder,
    FolderPlus,
    FilePlus,
    FileSymlink,
    FileCheckCorner
} from "lucide-react";

import type {NavigateFunction} from "react-router-dom";
import type {AssetsCount} from "../../../../domains/models/asset-management";
import type {StatCardData} from "../../../common/stat-cards/stat-cards";

export type QuickActionsConfig = {
    key: string;
    label: string;
    desc: string;
    href: string;
    icon: any;
    color: string;
    bg: string;
};

export const getAssetStatsCards = (
    data: AssetsCount,
    navigate: NavigateFunction
): StatCardData[] => {
    return [
        {
            key: "totalAssets",
            label: "Total Assets",
            value: data.assetCount.summary.total,
            icon: FolderOpen,
            color: "default",
            onClick: () =>
                navigate('/asset/inventory')
        },

        {
            key: "availableAssets",
            label: "Available (In Stock)",
            value: data.assetCount.summary.available,
            icon: CircleCheckBig,
            color: "green",
            onClick: () =>
                navigate('/asset/inventory', {
                    state: {
                        status: 'IN_STOCK'
                    }
                })
        },

        {
            key: "allocatedAssets",
            label: "Allocated (In Use)",
            value: data.assetCount.summary.allocated,
            icon: UserCheck,
            color: "blue",
            onClick: () =>
                navigate('/asset/inventory', {
                    state: {
                        status: "IN_USE"
                    }
                })
        },

        {
            key: "underMaintenanceAssets",
            label: "Under Maintenance",
            value: data.assetCount.summary.underMaintenance,
            icon: BrushCleaning,
            color: "orange",
            onClick: () =>
                navigate('/asset/inventory', {
                    state: {
                        status: "UNDER_MAINTENANCE"
                    }
                })
        },

        {
            key: "missingAssets",
            label: "Missing Assets",
            value: data.assetCount.summary.missing,
            icon: TriangleAlert,
            color: "red",
            onClick: () =>
                navigate('/asset/inventory', {
                    state: {
                        status: "MISSING"
                    }
                })
        },

        {
            key: "disposeAssets",
            label: "Disposed",
            value: data.assetCount.summary.disposed,
            icon: Shredder,
            color: "gray",
            onClick: () =>
                navigate('/asset/inventory', {
                    state: {
                        status: "DISPOSED"
                    }
                })
        }
    ];
};


export const AssetQuickActionsConfig: QuickActionsConfig[] = [
    {
        key: "add-category",
        label: "Add Category",
        desc: "Create a new asset category before adding assets",
        href: "/asset/category",
        icon: FolderPlus,
        color: "#2563EB",
        bg: "#DBEAFE"
    },

    {
        key: "add-asset",
        label: "Add Asset",
        desc: "Register a new asset into the inventory system",
        href: "/asset/category",
        icon: FilePlus,
        color: "#16A34A",
        bg: "#DCFCE7"
    },

    {
        key: "assign-asset",
        label: "Assign Asset",
        desc: "Directly allocate an IN_STOCK asset to an employee",
        href: "/asset/allocation",
        icon: FileSymlink,
        color: "#A020F0",
        bg: "#EBDBFD"
    },

    {
        key: "review-request",
        label: "Review Requests",
        desc: "Pending employee requests awaiting approval",
        href: "/asset/request",
        icon: FileCheckCorner,
        color: "#D97706",
        bg: "#FEF3C7"
    }
];